import { SoftcatApiUser } from 'softcat:types/softcat-api.ts';
import { SoftcatApiUtils } from 'softcat:utils/softcat-api.ts';

const create = async (data: Partial<SoftcatApiUser>): Promise<SoftcatApiUser> => {
    return SoftcatApiUtils.post<SoftcatApiUser>('/users', { body: data });
};

const findAll = async ({ limit = 10, page = 0, query = '', orderBy = '' }: { limit?: number; orderBy?: string; page?: number; query?: string } = {}): Promise<
    SoftcatApiUser[]
> => {
    const users = await SoftcatApiUtils.get<SoftcatApiUser[]>('/users');

    let filtered = [...users];

    if (query) {
        const pattern = query.toLowerCase();
        filtered = filtered.filter((user) => {
            return user.username.toLowerCase().includes(pattern) || user.email?.toLowerCase().includes(pattern) || user.id.toLowerCase().includes(pattern);
        });
    }

    if (orderBy) {
        const [field, direction] = orderBy.split(':');
        filtered = [...filtered].sort((a, b) => {
            const aValue = String(a[field as keyof SoftcatApiUser] ?? '');
            const bValue = String(b[field as keyof SoftcatApiUser] ?? '');
            const comparison = aValue.localeCompare(bValue);
            return direction === 'desc' ? -comparison : comparison;
        });
    }

    const start = page * limit; // NB: Assumes all previous pages had the same 'limit' value.
    return filtered.slice(start, start + limit);
};

const findOne = async ({ id }: { id: string }): Promise<SoftcatApiUser> => {
    return SoftcatApiUtils.get<SoftcatApiUser>(`/users/${id}`);
};

const update = async (data: Partial<SoftcatApiUser>): Promise<SoftcatApiUser> => {
    const { id, ...user } = data;

    return SoftcatApiUtils.put<SoftcatApiUser>(`/users/${id}`, { body: user });
};

export const UserService = {
    create,
    findAll,
    findOne,
    update,
};
